import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export default function FinanceTeam() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10" data-testid="finance-team-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="relative border border-[#D4AF37]/25 bg-[#0A0A0A] aspect-[4/5] max-w-md mx-auto w-full flex items-center justify-center"
          data-testid="finance-team-monogram"
        >
          <span className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] -translate-x-px -translate-y-px" aria-hidden="true" />
          <span className="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] translate-x-px translate-y-px" aria-hidden="true" />
          <div className="text-center">
            <img
              src="/images/logo.png"
              alt="Veritas Development Group monogram"
              className="h-24 w-auto mx-auto opacity-90"
              data-testid="finance-team-logo"
            />
            <p className="mt-6 font-display text-2xl tracking-[0.3em] text-[#D4AF37]">VDG</p>
            <p className="mt-2 text-[9px] tracking-[0.34em] uppercase text-[#A3A3A3]">Capital Advisory</p>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
        >
          <p className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-6" data-testid="finance-team-overline">
            Meet Our Finance Team
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.08] tracking-tight text-[#F5F5F5]" data-testid="finance-team-headline">
            Commercial
            <br />
            <span className="italic text-[#D4AF37]">Finance Broker</span>
          </h2>
          <p className="mt-8 max-w-lg text-base font-light leading-relaxed tracking-wide text-[#A3A3A3]" data-testid="finance-team-bio">
            A dedicated commercial finance broker with established relationships across regional banks, debt funds and private capital sources. Specializes in sourcing and structuring development, construction and transitional financing for multifamily, mixed-use and commercial assets — from first conversation through closing.
          </p>
          <p className="mt-6 text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]/60 italic" data-testid="finance-team-placeholder-note">
            Full team profile &amp; biography coming soon
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+18164056181"
              data-testid="speak-finance-team-button"
              className="flex items-center justify-center gap-2.5 bg-[#D4AF37] text-black px-10 py-4 text-[11px] tracking-[0.3em] uppercase font-medium hover:bg-[#F3E5AB] transition-colors duration-300"
            >
              <Phone size={13} strokeWidth={1.5} />
              Speak With Our Finance Team
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
